import { useEffect, useState } from "react";

/**
 * Returns `true` once the user scrolls past `threshold`, `false` when
 * back near the top. Extracted from `Header.tsx` (issue #140) so the
 * LocaleSwitcher can opt into the same sticky-compact pattern without
 * duplicating the scroll listener. Uses a passive listener + rAF to
 * stay within one paint frame per scroll event.
 */
export function useScrollPast(threshold = 40): boolean {
	const [past, setPast] = useState(false);

	useEffect(() => {
		if (typeof window === "undefined") return undefined;
		let frame = 0;
		const onScroll = () => {
			cancelAnimationFrame(frame);
			frame = requestAnimationFrame(() => {
				setPast(window.scrollY > threshold);
			});
		};
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => {
			cancelAnimationFrame(frame);
			window.removeEventListener("scroll", onScroll);
		};
	}, [threshold]);

	return past;
}

export default useScrollPast;
